var map = {
	"./ZoomPluginsModule.js": 920,
	"./es.upv.paella.canvasZoomInButtonPlugin.js": 354,
	"./es.upv.paella.canvasZoomOutButtonPlugin.js": 307,
	"./es.upv.paella.zoomInButtonPlugin.js": 902,
	"./es.upv.paella.zoomMenuButtonPlugin.js": 770,
	"./es.upv.paella.zoomOutButtonPlugin.js": 551,
	"./es.upv.paella.zoomPlugin.js": 746
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 109;